import { useProcessesWithField } from 'charts/common/useProcessesWithField';
import { useCallback, useMemo } from 'react';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import {
  ChartType,
  IssueChart,
} from 'shared/types/analytics';
import { customAccessFunction } from '../common/access';
import { EMPTY_VALUES_AND_LABELS, useGetChart } from '../common/hooks';
import { mapValuesAndLabels } from '../model/mapSeriesToRawData';
import { IssueChartContext, useIssueChartFilters } from 'charts/common/issueChartFilters';
import { ExtendedFieldTranslationKeys } from 'intl/keys';

export function useHsHazardType(): IssueChartContext {
  const processesWithHazardCategory = useProcessesWithField(
    IssueFieldNames.hazardCategory
  );
  const access = useCallback(() => {
    return Boolean(processesWithHazardCategory.length);
  }, [processesWithHazardCategory]);

  const filters = useIssueChartFilters({ chart: IssueChart.hsHazardType, processes: processesWithHazardCategory });
  const additionalParams = useMemo(
    () => ({
      visibleProcesses: processesWithHazardCategory.map(
        (process) => process._id
      ),
    }),
    [processesWithHazardCategory]
  );

  const { series, loading, load, reload, updatedAt } =
    useGetChart({ chart: IssueChart.hsHazardType, filters, additionalParams, initialSeries: EMPTY_VALUES_AND_LABELS });

  const rawData = useMemo(() => mapValuesAndLabels(series), [series]);

  return {
    filters,
    titleId: ExtendedFieldTranslationKeys.hazardCategory,
    chartType: ChartType.donut,
    canAccess: customAccessFunction(access),
    loading: !filters || loading,
    load,
    forceUpdate: reload,
    updatedAt: (): number => updatedAt,
    rawData,
  };
}
